export default __webpack_public_path__ + "static/media/DarkBlue0003.cc1f4ccb.png";